export default "__VITE_ASSET__9422119a__"